<template>
  <div>
    <span class="text-primary">
      <slot
        name="info"
      />
    </span>
    <feather-icon
      icon="UsersIcon"
      class="text-success cursor-pointer ml-1"
      size="16"
      @click="handleDeptShow"
    />
    <b-modal
      v-model="deptShow"
      body-class="dept-modal"
      size="xl"
      centered
      hide-footer
    >
      <iframe :src="src" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDept } from '@/api/system/dept'
import flowApi from '@/api/flow/index';

export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      deptShow: false,
      src: '',
    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
  },
  methods: {
    async handleDeptShow() {
      if (this.userAllInfo.staffId) {
        await this.onLoad()
        this.deptShow = true
      }
    },
    async onLoad() {
      getDept(this.params.id).then(deptRes => {
        const userId = this.userAllInfo.staffInfo.employmentCode
        const { deptCode } = deptRes.data.data
        const params = {
          userId,
        }
        flowApi.getAiisToken(params).then(res => {
          const token = res.data.data
          this.src = `https://aiis.mcc.sg/vue2.0/project-report/#/external-references?code=${deptCode}&token=${token}&userid=${userId}`
        })
      })
    },
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
  },
}
</script>

<style lang="scss">
.dept-modal{
  iframe{
    border: none;
    width: 100%;
    height: 70vh;
  }
}
</style>
